import $ from 'jquery';

$(document).ready(function() {
    $('.product-miniature-gamme').each(function() {
        var parents = $(this);

        parents.each(function() {
            var content = $(this).find('.product-miniature-content');
            var overlay = $(this).find('.product-miniature-overlay');
         
            var contentHeight = content.outerHeight(true);

            $(overlay).css('display', 'block');
            var overlayHeight = overlay.outerHeight(true);
            $(overlay).css('display', 'none');
            
            var height = contentHeight + overlayHeight;

            $(this).mouseenter(function() {
                if (window.matchMedia('(min-width: 1026px)').matches) {
                    $(this).css('height', height + 'px');
                }
            });

            $(this).mouseleave(function() {
                if (window.matchMedia('(min-width: 1026px)').matches) {
                    $(this).css('height', 'auto');
                }
            });
        });
        
    });

    // Product page
    /* Slider image */
    $('.slider-for-product').slick({
        asNavFor: '.slider-nav',
        arrows: false,
        responsive: [
            {
            breakpoint: 790,
                settings: {
                    dots: true
                }
            }
        ]
    });
    
    $('.slider-nav').slick({
        slidesToShow: 3,
        focusOnSelect: true,
        asNavFor: '.slider-for-product',
        arrows: false,
    });

    // Right column sticky on desktop
    if (window.matchMedia('(min-width: 1025px)').matches) {
        var headerHeight = $('.header').outerHeight(true);
        $('.top-product .right-column').css('top', headerHeight + 'px');
    }

    // Related products
    $('.related-products-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

     // Related products
     $('.products-slider .views-element-container').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

    $('.content-product .read-more').on("click",function() {
        var offsetTop = $('.features').offset().top;
        var headerHeight = $("header").height();
        $('html, body').animate({
            scrollTop: offsetTop-headerHeight
        }, 500);
    });
});
